import { IOrderDeclined } from 'my-poppies-b2b-types';

import { timestampMockHelpers } from '@/utils/timestampMockHelpers';

export const dummyDataOrdersDeclined: IOrderDeclined[] = [
  {
    userRole: 'EVA',
    id: 'first-declined-order',
    createdBy: 'SAM',
    createdAt: timestampMockHelpers.now,
    updatedBy: 'SAM',
    updatedAt: timestampMockHelpers.now,
    sender: 'SOME_SENDER',
    priority: 'HIGH',
    customerId: 'customer-0',
    customerPretty: 'Customer Name Pretty',
    status: 'DECLINED',
    positions: [
      { positionId: 'kleine-kapseln-40g', amount: 123 },
      { positionId: 'große-kapseln-120g', amount: 14 },
    ],
    reason: 'The reason why this was declined is not easy to explain hehehe',
  },
  {
    userRole: 'EVA',
    id: 'second-declined-order',
    createdBy: 'SAM',
    createdAt: timestampMockHelpers.now,
    updatedBy: 'SAM',
    updatedAt: timestampMockHelpers.now,
    sender: 'SOME_SENDER',
    priority: 'LOW',
    customerId: 'customer-1',
    customerPretty: 'Customer Name Pretty',
    status: 'DECLINED',
    positions: [{ positionId: 'palette-800-100', amount: 17 }],
    reason: 'Was declined because blablabla....',
  },
];
